import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
    Stepper,
    Step,
    StepButton,
    CircularProgress
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
// Form related
import { Formik, Form } from 'formik';
import MomentUtils from '@date-io/moment';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
// Forms
import BusinessDetails from "./Forms/BusinessDetails";
import CustomerDetails from "./Forms/CustomerDetails";
import BillingDetails from "./Forms/BillingDetails";
import AwareForm from "./Forms/AwareForm";
import MultipleNSAForm from "./Forms/MultipleNSAForm";
import CUF from "./Forms/CUF";
import Signing from "./Forms/Signing";
import companyFormModel from "./FormModel/companyFormModel";
import companyFormInitialValue from "./FormModel/companyFormInitialValue";

import connectionFormStyle from "../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const { formId, formField } = companyFormModel;
const useStyles = makeStyles(connectionFormStyle);

// Form related configs
const steps = ['Business Details', 'Customer Details', 'Billing Details', 'Are You Aware', 'Multiple/Bulk NSA Form', 'Customer Understanding Form', 'Signing'];

function renderStepContent(step, setFieldValue, values, isSubmitting, setServiceData, serviceData) {
    switch (step) {
        case 0:
            return <BusinessDetails formField={formField} />;
        case 1:
            return <CustomerDetails formField={formField} setFieldValue={setFieldValue} values={values} />;
        case 2:
            return <BillingDetails formField={formField} setFieldValue={setFieldValue} values={values} />;
        case 3:
            return <AwareForm formField={formField} values={values} />;
        case 4:
            return <MultipleNSAForm formField={formField} values={values} setFieldValue={setFieldValue} setServiceData={setServiceData} />;
        case 5:
            return <CUF formField={formField} values={values} serviceData={serviceData} />;
        case 6:
            return <Signing formField={formField} setFieldValue={setFieldValue} values={values} isSubmitting={isSubmitting} />;
        default:
            return <div>Not Found</div>;
    }
}


export default function Company() {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = React.useState({});
    const [serviceData, setServiceData] = useState([]);

    async function submitForm(values, actions) {
        //alert(JSON.stringify(values, null, 2));
        console.log(values);
        actions.setSubmitting(false);

        //setActiveStep(activeStep);
    }

    function handleSubmit(values, actions) {
        if (isLastStep()) {
            submitForm(values, actions);
        } else {
            handleComplete();
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                  // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Stepper nonLinear alternativeLabel activeStep={activeStep} className={classes.stepper}>
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepButton onClick={handleStep(index)} completed={completed[index]}>
                                    {label}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Formik
                            initialValues={companyFormInitialValue}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting, setFieldValue, values }) => (
                                <Form id={formId}>
                                    {renderStepContent(activeStep, setFieldValue, values, isSubmitting, setServiceData, serviceData)}

                                    <div className={classes.bottomNavigationButtons}>
                                        {activeStep !== 0 && (
                                            <Button onClick={handleBack} className={classes.button}>
                                                Back
                                            </Button>
                                        )}
                                        <div className={classes.wrapper}>
                                            {!isLastStep() ?
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                >
                                                    Save & Continue
                                                </Button>
                                            : null}
                                            {isSubmitting && (
                                                <CircularProgress
                                                    size={24}
                                                    className={classes.buttonProgress}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </MuiPickersUtilsProvider>
                </GridItem>
            </GridContainer>
        </div>
    );
}
